import { useQuery } from '@tanstack/react-query';
import { client, OverallStatusFilter } from '../../api';
import { RxFilterValues } from '../../types';

export const useHasAwaitingOffice = (search: string, filterValues: RxFilterValues) => {
  const { prescriber, office, drug, drug_category } = filterValues;

  return useQuery({
    queryKey: ['has-awaiting-office', search, prescriber, office, drug, drug_category],
    queryFn: () =>
      client
        .get('/rxs/awaiting-office-count', {
          params: {
            search,
            prescriber_npi: prescriber,
            office_name: office,
            drug_name: drug,
            drug_category,
            overall_status: OverallStatusFilter.InProgress,
          },
        })
        .then((res) => res.data.count > 0),
  });
};
